import { render, staticRenderFns } from "./LoVotesList.vue?vue&type=template&id=a5ab7228&scoped=true"
import script from "./LoVotesList.vue?vue&type=script&lang=js"
export * from "./LoVotesList.vue?vue&type=script&lang=js"
import style0 from "./LoVotesList.vue?vue&type=style&index=0&id=a5ab7228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ab7228",
  null
  
)

export default component.exports